import { languages as mlangs } from 'mostra';
import { merge } from 'lodash';

const languages = {
  en: {
    message: {
      hello: '{msg} world',
    },
    sign_in: {
      form_email_label: 'Email',
      form_email_placeholder: 'your-email@example.com',
      form_password_label: 'Password',
      form_password_placeholder: 'At least 8 characters',
      forgot_password: ['Forgot your password? ', 'Recover Password'],
      sign_up_link: ['Don\'t have an account? ', 'Sign Up'],
    },
    reset: {
      form_email_label: 'Email',
      form_email_placeholder: 'taro@granstra.com',
      submit: 'Recover',
      sign_in: ['Already have an account? ', 'Sign In'],
    },
    sign_up: {
      message_text: 'You will need to sign up to make an enquiry. Please sign up and then contact us again.',
      title_sub: 'User Registration',
      description_heading: 'When you register as a user, you can do the following:',
      description_items: [
        {
          text: 'Contact Exhibitors',
          img_alt: 'Contact exhibitors (exchange messages)',
        },
        {
          text: ['Manage brands and products with a favorite list', ''],
          img_alt: 'Manage brands and products with a favorite list',
        },
        {
          text: 'Stay up-to-date on the latest exhibitions',
          img_alt: 'Stay up-to-date on the latest exhibitions',
        },
      ],
      form_label: {
        email: {
          label: 'Email',
          placeholder: 'your-email@example.com',
        },
        password: {
          label: 'Password',
          placeholder: 'Password with at least 8 characters',
        },
      },
      term: [
        'By starting to use the service, you agree to Granstra\'s ', 'Terms of Use ', 'and ', 'Privacy Policy', '.',
      ],
      auth_text: 'Register',
      sign_in: ['Already have an account? ', 'Sign In'],
      supplier: ['Are you an exhibitor? ', 'Exhibit Brands'],
    },
    register: {
      message_text: 'User registration is required.',
      title_sub: 'User Registration',
      description: ['Please register your user information.', 'User information will be used to contact exhibitors.'],
      alert_description: ['You have registered with this email address.', 'If this email is incorrect, please log out and sign up again.'],
      alert_logout: 'Log Out',
      form_heading: 'Contact person information',
      form_caution: 'Please register jpg/png/gif image data',
      submit_text: 'Register User Info',
    },
    user_info: {
      company: 'Company name / Store name',
      department: {
        label: 'Department / Position',
        placeholder: 'Product Planning Dept.',
      },
      name: {
        label: 'Contact person\'s name',
        placeholder: 'Taro Jackson',
      },
      kana: {
        label: 'Kana',
        placeholder: 'Taro Jackson',
      },
      phone: {
        label: 'Phone number',
        placeholder: '09012345678',
      },
      video_call: {
        label: 'Video call',
        placeholder: 'https://meet.google.com/☓☓☓☓☓☓☓☓☓☓☓☓',
      },
      image: {
        label: 'Profile picture',
        input_text: 'Drag & drop files to this area',
        input_select: 'Select File',
        input_delete: 'Delete',
        cancel_crop: 'Cancel',
        crop: 'Save Image',
        caution: 'Please register jpg/png square data.',
      },
      required: 'Required',
      optional: 'Optional',
      public: 'Public',
      private: 'Private',
    },
    company_info: {
      name: {
        label: 'Company name / Store name',
        placeholder: 'GRANSTRA inc.',
      },
      phone: {
        label: 'Company phone number',
        placeholder: '09012345678',
      },
      country: {
        label: 'Country',
        placeholder: 'Please select your country',
      },
      zip: {
        label: 'Postal / ZIP code',
        placeholder: '0000000 (without hyphen)',
      },
      province: {
        label: 'Province',
        placeholder: 'Tokyo',
      },
      city: {
        label: 'City',
        placeholder: 'Aobadai, Meguro-ku',
      },
      address: {
        label: 'Street name and address',
        placeholder: 'Aoba st. 1-1-1',
      },
      building: {
        label: 'Building Name / Room No.',
        placeholder: '#203, ✗✗✗Building',
      },
      website: {
        label: 'Website link',
        placeholder: 'https://granstra.com/',
      },
      type_of_business: 'Type of industry',
      intro: {
        label: 'Company introduction',
        placeholder: 'Please write an introduction of your company.',
      },
    },
    footer: {
      text: ['A new type of online exhibition that connects "brands" and "buyers".', ''],
      term: 'Terms of Use',
      privacy: 'Privacy Policy',
      contact: 'Contact',
    },
  },
  ja: {
    message: {
      hello: 'おはようございます',
    },
    sign_in: {
      form_email_label: 'メールアドレス',
      form_email_placeholder: 'メールアドレスを入力してください',
      form_password_label: 'パスワード',
      form_password_placeholder: '8文字以上',
      forgot_password: ['パスワードを忘れた方は', 'こちら'],
      sign_up_link: ['まだアカウントをお持ちでない方は', 'こちら'],
    },
    reset: {
      form_email_label: 'メールアドレス',
      form_email_placeholder: 'taro@granstra.com',
      submit: 'メールを送信する',
      sign_in: ['サインインは', 'こちら'],
    },
    sign_up: {
      message_text: 'お問い合わせにはサインアップが必要になります。サインアップ後に再お問い合わせをお願いします。',
      title_sub: 'ユーザ登録',
      description_heading: 'ユーザ登録をするとこんなことができます',
      description_items: [
        {
          text: '出展者にお問い合わせ',
          img_alt: '出展者にお問い合わせ（メッセージのやり取り）',
        },
        {
          text: ['ブランドや商品を', 'お気に入りリストで管理'],
          img_alt: '興味のあるブランドや商品をお気に入りリストで管理',
        },
        {
          text: '最新の展示会の情報を入手',
          img_alt: '最新の展示会の情報を入手',
        },
      ],
      form_label: {
        email: {
          label: 'メールアドレス',
          placeholder: 'メールアドレスを入力してください',
        },
        password: {
          label: 'パスワード',
          placeholder: '8文字以上のパスワードを設定してください',
        },
      },
      term: [
        'サービスのご利用開始とともに、Granstraの', '利用規約', 'と', 'プライバシーポリシー', 'に同意したものといたします。',
      ],
      auth_text: 'ユーザ登録をする',
      sign_in: ['すでにアカウントをお持ちの方は', 'こちら'],
      supplier: ['出展したい方は', 'こちら'],
    },
    register: {
      message_text: 'ユーザ情報の登録が必要です。',
      title_sub: 'ユーザ登録',
      description: ['ユーザ情報の登録をお願いします。', 'ユーザ情報は出展者とのお問い合わせで使用されます。'],
      alert_description: ['このメールアドレスで登録されました。', '誤りの場合は、ログアウトして再度サインアップをお願いします。'],
      alert_logout: 'ログアウト',
      form_heading: '担当者情報',
      form_caution: 'jpg/png/gifの画像データを登録してください',
      submit_text: 'ユーザ情報を登録する',
    },
    user_info: {
      company: '企業名/店名/屋号',
      department: {
        label: '部署/役職',
        placeholder: '製品企画部',
      },
      name: {
        label: '担当者名',
        placeholder: '倍屋太郎',
      },
      kana: {
        label: 'よみがな',
        placeholder: 'ばいやたろう',
      },
      phone: {
        label: '電話番号',
        placeholder: '09012345678',
      },
      video_call: {
        label: 'ビデオ通話',
        placeholder: 'https://meet.google.com/☓☓☓☓☓☓☓☓☓☓☓☓',
      },
      image: {
        label: '写真登録',
        input_text: 'このエリアにファイルをドラッグ＆ドロップ',
        input_select: 'ファイルを選択',
        input_delete: '削除',
        cancel_crop: 'キャンセル',
        crop: '適用',
        caution: 'jpg/pngの正方形のデータを登録してください。',
      },
      required: '必須',
      optional: '任意',
      public: '公開',
      private: '非公開',
    },
    company_info: {
      name: {
        label: '企業名/店名/屋号',
        placeholder: '株式会社GRANSTRA',
      },
      phone: {
        label: '電話番号(代表)',
        placeholder: '09012345678',
      },
      country: {
        label: '国',
        placeholder: '国を選んでください',
      },
      zip: {
        label: '郵便番号',
        placeholder: '1530042(ハイフンなし)',
      },
      province: {
        label: '都道府県',
        placeholder: '東京都',
      },
      city: {
        label: '市区町村',
        placeholder: '目黒区青葉台',
      },
      address: {
        label: '町名・番地',
        placeholder: '1-1-1',
      },
      building: {
        label: '建物名・部屋番号',
        placeholder: '✗✗✗ビルディング2F 203号室',
      },
      website: {
        label: 'ホームページURL',
        placeholder: 'https://granstra.com/',
      },
      type_of_business: '業種',
      intro: {
        label: '企業紹介',
        placeholder: '企業の紹介を入れてください',
      },
    },
    footer: {
      text: ['「ブランド」と「バイヤー」をつなぐ、', '新しいカタチのオンライン展示会。'],
      term: '利用規約',
      privacy: 'プライバシーポリシー',
      contact: 'お問い合わせ',
    },
  },
};

export default merge(languages, mlangs.langs);
